const question1 = {
    'question': 'Kogo obejmuje interwencja kryzysowa?',
    'answer': 'Interwencja kryzysowa może być udzielana osobom indywidualnym, rodzinom lub grupom. Celem interwencji jest przywrócenie równowagi psychicznej i umiejętności samodzielnego radzenia sobie. W ramach interwencji kryzysowej udziela się pomocy psychologicznej, poradnictwa socjalnego lub innych form wsparcia.',
}

export default question1;